import styled from 'styled-components';

export const SContact = styled('p')`
    font-weight: bold;
    text-align: center;

    a {
        text-decoration: underline;
    }
`;

export const SYoutubeBannerLink = styled('a')`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3rem;
    text-align: center;

    &:hover {
        text-decoration: none;
    }
`;

export const SYoutubeBannerTitle = styled('p')`
    color: ${({ theme }) => theme.color.black};
    font-size: 2rem;
    font-weight: bold;
`;

export const SYoutubeBannerSubtitle = styled(SYoutubeBannerTitle)`
    margin-bottom: 2rem;

    ${SYoutubeBannerLink}:hover & {
        text-decoration: underline;
    }
`;

export const SYoutubeBanner = styled('img')`
    width: 70.4rem;
`;
